import React, { useRef, useEffect } from 'react';
import Header from 'modules/Shared/components/Header/Header';
import Footer from 'modules/Shared/components/Footer/Footer';
import Contact from 'modules/MainModule/components/Contact/Contact';
import StartNow from 'modules/Shared/components/StartNow/StartNow';
import FlightChecker from 'modules/MainModule/components/FlightChecker/FlightChecker';
import { colorBackgroundBrightness } from 'data/common.data';
import '../IndustryType.scss';
import { Helmet, HelmetProvider } from 'react-helmet-async';

const TravelTech = (props: any) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    });
    const headerBg: string = '/images/backgrounds/ALEG-Image-TravelTech_Header.jpg'
    const styleData = { backgroundImage: `linear-gradient(${colorBackgroundBrightness}, ${colorBackgroundBrightness}), url(${headerBg})` };
    const contentData: string = 'AirLegit\'s platform and integration capabilities offer a wide range of possibilities for product design, enhancement, and extension.';
    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>AirLegit Tools for Travel Technology Innovators</title>
                    <meta name='description' content={contentData} />
                </Helmet>
            </HelmetProvider>
            <Header />
            <div className='page-min-height industry-type-data-container'>
                <div className='header-container container-side-padding container-content-padding' style={styleData}>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6'>
                                    <h1>
                                        Travel Technology Innovators
                                    </h1>
                                    <p className=''>
                                        AirLegit's platform and integration capabilities offer a wide range of possibilities for product design, enhancement, and extension.
                                    </p>
                                </div>
                                <div className='col-md-6'>
                                    <div className='logo-wrapper'>
                                        <img src='/images/others/ALEG-Image-Header_TabletPhone.png' alt='airlegit-devices' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='content-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-md-6 order-2 order-md-1'>
                                    <h3 className='text-med'>
                                        AirLegit&#169; for Travel Technology Innovators
                                    </h3>
                                    <p className=''>
                                        AirLegit's flight disruption automation and remediation services help technology companies fill gaps in their service offerings, broaden their services with seamless customer support solutions, and improve operational efficiency using AirLegit's platform.
                                    </p>
                                    <p className=''>
                                        With real-time data and advanced travel-related algorithms, AirLegit automatically identifies flight disruptions such as delays, cancellations, and diversions to deliver proactive recommendations, flight rebooking, insurance filing, and timely updates to affected passengers.
                                    </p>
                                    <p className=''>
                                        When technology companies integrate AirLegit's platform, they leverage tools to reduce traveler inconvenience, proactively manage customer expectations, offer alternative travel options, and mitigate potential losses. In addition, automation can enable companies to gain better insights into the root causes of flight disruptions, track performance metrics, and optimize their response strategies.
                                    </p>
                                    <p className='no-margin'>
                                        Read about the <a href='https://www.battleface.com/en-eu/battleface-partners-with-airlegit-to-launch-flightguard48-globally/' target='_blank' rel='noopener noreferrer' className='text-link'>Battleface partnership with AirLegit.</a>
                                    </p>
                                </div>
                                <div className='col-md-6 order-1 order-md-2'>
                                    <div className='bordered-img-wrapper'>
                                        <img src='/images/others/ALEG-Image-TravelTech_Body_1.jpg' alt='frame' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='colored-container container-side-padding container-content-padding'>
                    <div className='container-small-width'>
                        <div className='container no-padding'>
                            <div className='row'>
                                <div className='col-12 no-padding'>
                                    <FlightChecker />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <StartNow />
            </div>
            <Contact />
            <Footer />
        </>
    );
};

export default TravelTech;